import { render, staticRenderFns } from "./PairedArticleBanner.vue?vue&type=template&id=d6ca0422&scoped=true"
import script from "./PairedArticleBanner.vue?vue&type=script&lang=js"
export * from "./PairedArticleBanner.vue?vue&type=script&lang=js"
import style0 from "./PairedArticleBanner.vue?vue&type=style&index=0&id=d6ca0422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ca0422",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fpaired-article-banner%2FPairedArticleBanner.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports